import { Check } from "lucide-react";
import { DateRange } from "react-day-picker";

import { Row } from "@/components/Row";
import { Calendar } from "@/components/ui/calendar";
import {
  DropdownMenuCheckboxItem,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
} from "@/components/ui/dropdown-menu";

import { dateFilterOptions } from "@/lib/constants";
import { getScreenFromPathname, mixpanelUtils } from "@/lib/mixpanel/mixpanel";
import { cn } from "@/lib/utils";
import { DateFilterOption } from "@/types";

export const FilterSubMenuDatePicker = ({
  dateRange,
  label,
  selected,
  setDateRange,
  setSelected,
}: {
  dateRange?: DateRange;
  label: string;
  selected: DateFilterOption;
  setDateRange: (dateRange?: DateRange) => void;
  setSelected: (selected: DateFilterOption) => void;
}) => {
  return (
    <DropdownMenuSub>
      <DropdownMenuSubTrigger>{label}</DropdownMenuSubTrigger>
      <DropdownMenuSubContent className="p-0">
        {dateFilterOptions.map((option) => (
          <DropdownMenuCheckboxItem
            key={option.value}
            checked={selected === option.value}
            onCheckedChange={() => {
              mixpanelUtils.trackFilterAndSortOptionSelected(
                getScreenFromPathname(location.pathname),
                label,
                option.value,
              );
              setSelected(option.value);
            }}
          >
            {option.label}
          </DropdownMenuCheckboxItem>
        ))}
        <DropdownMenuSub>
          <DropdownMenuSubTrigger>
            <Row className="items-center gap-2">
              <Check
                className={cn(
                  "h-4 w-4",
                  selected !== DateFilterOption.Custom && "text-transparent",
                )}
              />
              <span>Custom Range...</span>
            </Row>
          </DropdownMenuSubTrigger>
          <DropdownMenuSubContent>
            <Calendar
              mode="range"
              selected={dateRange}
              onSelect={setDateRange}
            />
          </DropdownMenuSubContent>
        </DropdownMenuSub>
      </DropdownMenuSubContent>
    </DropdownMenuSub>
  );
};
